import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/password';

function createPasswordSuccess(state, action) {
  const { code, message } = action.payload;
  state.createPassword = {
    success: true,
    error: false,
    code,
    message,
  };
}

function createPasswordError(state, action) {
  const { code, message } = action.payload;
  state.createPassword = {
    success: false,
    error: true,
    code,
    message,
  };
}

const createPassword = createAction('createPassword');

const passwordReducer = createSlice({
  name: 'password',
  initialState,
  reducers: {
    createPasswordSuccess,
    createPasswordError,
  },
});

export const passwordActions = {
  ...passwordReducer.actions,
  createPassword,
};

export default passwordReducer.reducer;
